import type { ICaseWorkflowStateResponse, IUpsertCaseWorkflowState } from '@escloud/types';

import type { ApiClient } from './api-client';

export class WorkflowStateService {
    constructor(private api: ApiClient) {}

    getByKey(caseId: string, key: string): Promise<ICaseWorkflowStateResponse | null> {
        return this.api.get(`/cases/${caseId}/workflow-state/${key}`);
    }

    upsert(
        caseId: string,
        key: string,
        payload: IUpsertCaseWorkflowState
    ): Promise<ICaseWorkflowStateResponse> {
        return this.api.put(`/cases/${caseId}/workflow-state/${key}`, payload);
    }
}
